import React, { useEffect, useState, useRef } from "react";
import ongoingService from "../../services/ongoingbooking";
import { toast } from "react-toastify";
import { handleErrors } from "../../utils/errorHandler";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@mui/lab";
import { Card, CardContent, Typography } from "@mui/material";
// import EventNoteIcon from "@mui/icons-material/EventNote";
import WorkIcon from "@mui/icons-material/Work";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
const MyServices = () => {
  const [bookings, setBookings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedBookingGuid, setSelectedBookingGuid] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [requoteComplete, setRequoteComplete] = useState(null);
  const [showModalComplete, setShowModalComplete] = useState(false);
  const [timelineDetails, setTimelineDetails] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);

  const renderBookStatusBadge = (bookStatus) => {
    let badgeClass = "outlined-badge badge-purple";
    switch (bookStatus) {
      case "Success":
        badgeClass = "outlined-badge badge-green";
        break;
      case "Initiated":
        badgeClass = "outlined-badge badge-gray";
        break;
      case "Vendor Assigned":
        badgeClass = "outlined-badge badge-blue";
        break;
      case "Vendor Re-Assigned":
        badgeClass = "outlined-badge badge-yellow";
        break;
      case "Vendor Re-Quoted":
        badgeClass = "outlined-badge badge-purple";
        break;
      case "Re-Quote Accepted":
        badgeClass = "outlined-badge badge-blue";
        break;
      case "Cancelled":
        badgeClass = "outlined-badge badge-orange";
        break;
      case "Completed":
        badgeClass = "outlined-badge badge-indigo";
        break;
      default:
        badgeClass = "outlined-badge badge-gray";
    }
    return <span className={`badge  ${badgeClass}`}>{bookStatus}</span>;
  };
  const iconMap = {
    Assigned: <WorkIcon />,
    Cancelled: <CloseIcon />,
  };
  const fetchBookings = async () => {
    try {
      const formData = {
        pageSize: 30,
        pageNo: 1,
        sParam: searchTerm,
        bookStatus: "",
        fromDate,
        toDate,
      };
      const response = await ongoingService.ongoingServicesBooking(formData);
      if (response.data.isSuccess) {
        setBookings(response.data.result);
      }
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
    }
  };
  useEffect(() => {
    fetchBookings();
  }, [fromDate, toDate]);
  const handleSearchClick = () => {
    setSearchTerm(searchInput);
  };
  useEffect(() => {
    if (searchTerm !== "") {
      fetchBookings();
    }
  }, [searchTerm]);

  const handleCancelBooking = async () => {
    try {
      await ongoingService.cancelServicesBooking(selectedBookingGuid);
      toast.success("Booking cancelled successfully");
      fetchBookings();
      setShowModal(false);
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
      setShowModal(false);
    }
  };

  const confirmCancel = (bookingGuid) => {
    setSelectedBookingGuid(bookingGuid);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const timelineformdate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date
      .toLocaleDateString("en-GB", options)
      .replace(",", "");

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} - ${formattedTime}`;
  };

  const fetchBookingDetails = async (bookingGuid) => {
    try {
      const response = await ongoingService.bookingDetails(bookingGuid);
      if (response.data.isSuccess) {
        setSelectedBooking(response.data.result);
        setTimelineDetails(response.data.result.bookingActivity || []);
        // setShowModals(true);
        setShowDialog(true);
        console.log("sekected", selectedBooking);
      }
    } catch (error) {
      toast.error("Failed to fetch booking details");
    }
  };
  const handleRequoteComplete = async () => {
    try {
      await ongoingService.reqouetServicesBooking(requoteComplete);
      toast.success("Mark As Complete  successfully");
      fetchBookings();
      setShowModalComplete(false);
    } catch (error) {
      let errorMessage = handleErrors(error);
      if (error.response && error.response.status === 500) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
      setShowModalComplete(false);
    }
  };
  const confirmComplete = (bookingGuid) => {
    setRequoteComplete(bookingGuid);
    setShowModalComplete(true);
  };
  return (
    <div>
      <div className="mb-4">
        <h3>Ongoing Bookings Details</h3>
      </div>
      <div className="filter-row">
        <div className="mt-3">
          <Flatpickr
            id="fromDate"
            className="date-filters"
            placeholder="Select From Date"
            value={fromDate}
            onChange={([date]) => setFromDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <Flatpickr
            id="toDate"
            className="date-filters"
            placeholder="Select To Date"
            value={toDate}
            onChange={([date]) => setToDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <div className="search-input">
            <input
              type="text"
              id="search"
              className="date-filters"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search...."
              ref={searchInputRef}
            />
          </div>
        </div>
        <div className=" mt-3">
          <div className="">
            <button
              className="date-filters btn orange-btn text-white"
              onClick={handleSearchClick}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 gap-4">
          {bookings.length === 0 ? (
            <div className="text-center mt-4">
              <h6>No ongoing bookings available.</h6>
            </div>
          ) : (
            bookings.map((booking, index) => (
              <div
                key={booking.id}
                className="ongoning-details-card rounded-lg p-4 border mt-3"
              >
                <div className="ongoing-status flex justify-between items-center mb-2">
                  <h6 className="booking-details">
                    <Link
                      className="btn-link"
                      onClick={() => fetchBookingDetails(booking.bookingGuid)}
                    >
                      {booking.bookingNo}
                    </Link>{" "}
                    | {formatDate(booking.bookedOn)}
                  </h6>
                  <div>{renderBookStatusBadge(booking.bookStatus)}</div>
                </div>
                <div className="mb-1">
                  <h5>{booking.serviceName}</h5>
                </div>
                <div className="user-details mb-1">
                  Vendor - {booking.vendorName || "N/A"}, PhoneNo -{" "}
                  {booking.vendorPhoneNo ? (
                    <a href={`tel:${booking.vendorPhoneNo}`}>
                      {booking.vendorPhoneNo}
                    </a>
                  ) : (
                    "N/A"
                  )}
                  , Email -{" "}
                  {booking.vendorEmailAddress ? (
                    <a href={`mailto:${booking.vendorEmailAddress}`}>
                      {booking.vendorEmailAddress}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </div>

                <div className="quoted-button gap-2">
                  {booking.bookStatus === "Success" && (
                    <button
                      className="badge bg-danger"
                      onClick={() => confirmCancel(booking.bookingGuid)}
                    >
                      Cancel
                    </button>
                  )}
                  {booking.bookStatus === "Vendor Re-Quoted" && (
                    <button
                      className="badge bg-success"
                      onClick={() => confirmComplete(booking.bookingGuid)}
                    >
                      Accept
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Bootstrap Modal for Confirmation */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        style={{ maxWidth: "90%", margin: "0 auto" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this booking?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="badge bg-secondary"
            onClick={() => setShowModal(false)}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="badge bg-danger"
            onClick={handleCancelBooking}
          >
            Yes, Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModalComplete}
        onHide={() => setShowModalComplete(false)}
        style={{ maxWidth: "90%", margin: "0 auto" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Re-qoute Completed?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="badge bg-secondary"
            onClick={() => setShowModalComplete(false)}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="badge bg-danger"
            onClick={handleRequoteComplete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent>
          <div className="d-flex justify-content-lg-start ">
            <h3 className="me-2">Booking Details :</h3>
            <span className="mt-2">
              {selectedBooking ? (
                <>{renderBookStatusBadge(selectedBooking.bookStatus)}</>
              ) : (
                <p>Loading...</p>
              )}
            </span>
          </div>

          {selectedBooking ? (
            <>
              <div className="row mt-4">
                <div className="col-lg-4">
                  {" "}
                  <p>
                    <strong>Booking No:</strong> {selectedBooking.bookingNo}
                  </p>
                </div>
                <div className="col-lg-4">
                  <p>
                    <strong>Service Name:</strong> {selectedBooking.serviceName}
                  </p>
                </div>
                <div className="col-lg-4">
                  {" "}
                  <p>
                    <strong>Booked On:</strong>{" "}
                    {formatDate(selectedBooking.bookedOn)}
                  </p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-4">
                  {" "}
                  <p>
                    <strong>Vendor Name:</strong>{" "}
                    {selectedBooking.vendorName || "N/A"}
                  </p>
                </div>
                <div className="col-lg-4">
                  <p>
                    <strong>Vendor Phone No:</strong>{" "}
                    {selectedBooking.vendorPhoneNo ? (
                      <a href={`tel:${selectedBooking.vendorPhoneNo}`}>
                        {selectedBooking.vendorPhoneNo}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
                <div className="col-lg-4">
                  {" "}
                  <p>
                    <strong>Vendor Email:</strong>{" "}
                    {selectedBooking.vendorEmailAddress ? (
                      <a href={`mailto:${selectedBooking.vendorEmailAddress}`}>
                        {selectedBooking.vendorEmailAddress}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <p>Loading...</p>
          )}

          <h4 className="mt-3">Assign History</h4>
          <Timeline position="alternate">
            {timelineDetails.length > 0 ? (
              timelineDetails.reverse().map((activity, index) => (
                <TimelineItem key={index}>
                  <TimelineOppositeContent
                    sx={{ m: "auto 0" }}
                    align="right"
                    variant="body2"
                    color="text.secondary"
                    className="date-sm-hide"
                  >
                    {timelineformdate(activity.addedOn)}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot color="primary">
                      {iconMap[activity.activityType] || <WorkIcon />}
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="body2" color="textSecondary">
                          <strong>
                            {renderBookStatusBadge(activity.activityType)}
                          </strong>
                        </Typography>
                        <br />
                        <Typography variant="body2" color="textSecondary">
                          {activity.activityDesc}
                        </Typography>
                      </CardContent>
                    </Card>
                  </TimelineContent>
                </TimelineItem>
              ))
            ) : (
              <Typography variant="body2">
                No Assign activities available.
              </Typography>
            )}
          </Timeline>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowDialog(false)}
            className="badge bg-danger"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyServices;
